export const APP_ENV: string = window.env.SERVICE_ENV;

export const isDevelopment: boolean = ['local', 'stage-1', 'stage-2'].includes(
  APP_ENV,
);
